import {
  LOGIN_GYM_REQUEST,
  LOGIN_GYM_SUCCESS,
  LOGIN_GYM_FAILURE,
  CREATE_USER_REQUEST,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAILURE,
  GET_USERS_REQUEST,
  GET_USERS_SUCCESS,
  GET_USERS_FAILURE,
  CREATE_TRAINER_REQUEST,
  CREATE_TRAINER_SUCCESS,
  CREATE_TRAINER_FAILURE,
  GET_TRAINERS_REQUEST,
  GET_TRAINERS_SUCCESS,
  GET_TRAINERS_FAILURE,
  REGISTER_ENTRY_REQUEST,
  REGISTER_ENTRY_SUCCESS,
  REGISTER_ENTRY_FAILURE,
  REGISTER_TRAINER_ENTRY_REQUEST,
  REGISTER_TRAINER_ENTRY_SUCCESS,
  REGISTER_TRAINER_ENTRY_FAILURE,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  GET_USER_FAIL,
  CREATE_PAYMENT_REQUEST,
  CREATE_PAYMENT_SUCCESS,
  CREATE_PAYMENT_FAILURE,
  GET_USER_PAYMENTS_REQUEST,
  GET_USER_PAYMENTS_SUCCESS,
  GET_USER_PAYMENTS_FAILURE,
  GET_MONTHLY_BALANCE_REQUEST,
  GET_MONTHLY_BALANCE_SUCCESS,
  GET_MONTHLY_BALANCE_FAILURE,
  GET_GYM_BALANCE_REQUEST,
  GET_GYM_BALANCE_SUCCESS,
  GET_GYM_BALANCE_FAILURE,
 
} from './Actions/actionTypes';

const initialState = {
  gym: JSON.parse(localStorage.getItem('gym')) || null,
  loading: false,
  error: null,
  token: null,
  userCreated: null, 
  userLoading: false,
  userError: null,
  users: [],
  usersTotal: 0,
  usersLoading: false,
  usersError: null,
  trainerCreated: null,
  trainerLoading: false,
  trainerError: null,
  trainers: [],
  trainersTotal: 0,
  trainersLoading: false,
  trainersError: null,
  entryLoading: false,
  entryMessage: null,
  entryError: null,
  entryUserData: null,
  trainerEntryLoading: false,
  trainerEntryMessage: null,
  trainerEntryError: null,
  user: null,
  userLoading: false,
  userError: null,
  paymentLoading: false,
  paymentError: null,
  userPayments: [],
  monthlyBalance: null,
  gymBalance: null,
};

const rootReducer = (state = initialState, action) => {
  console.log('ACTION:', action);
  switch (action.type) {
    case LOGIN_GYM_REQUEST: {
      const newState = {
        ...state,
        loading: true,
        error: null
      };
      console.log('STATE AFTER LOGIN_GYM_REQUEST:', newState);
      return newState;
    }
      case LOGIN_GYM_SUCCESS: {
      const newState = {
        ...state,
        loading: false,
        gym: action.payload.gym || null,
        token: action.payload.token || null,
        error: null
      };
      // Guarda el gym en localStorage
      if (newState.gym) {
        localStorage.setItem('gym', JSON.stringify(newState.gym));
      }
      console.log('STATE AFTER LOGIN_GYM_SUCCESS:', newState);
      return newState;
    }
    case LOGIN_GYM_FAILURE: {
      const newState = {
        ...state,
        loading: false,
        error: action.payload
      };
      console.log('STATE AFTER LOGIN_GYM_FAILURE:', newState);
      return newState;
    }
     case CREATE_USER_REQUEST: {
      return {
        ...state,
        userLoading: true,
        userError: null,
        userCreated: null
      };
    }
    case CREATE_USER_SUCCESS: {
      return {
        ...state,
        userLoading: false,
        userCreated: action.payload,
        userError: null
      };
    }
    case CREATE_USER_FAILURE: {
      return {
        ...state,
        userLoading: false,
        userError: action.payload
      };
    }
    case GET_USERS_REQUEST:
      return {
        ...state,
        usersLoading: true,
        usersError: null
      };
  case GET_USERS_SUCCESS:
  return {
    ...state,
    usersLoading: false,
    users: action.payload.users,
    usersTotal: action.payload.total,
    usersError: null
  };
    case GET_USERS_FAILURE:
      return {
        ...state,
        usersLoading: false,
        usersError: action.payload
      };
      case CREATE_TRAINER_REQUEST:
  return {
    ...state,
    trainerLoading: true,
    trainerError: null,
    trainerCreated: null
  };
case CREATE_TRAINER_SUCCESS:
  return {
    ...state,
    trainerLoading: false,
    trainerCreated: action.payload,
    trainerError: null
  };
case CREATE_TRAINER_FAILURE:
  return {
    ...state,
    trainerLoading: false,
    trainerError: action.payload
  };
  case GET_TRAINERS_REQUEST:
  return {
    ...state,
    trainersLoading: true,
    trainersError: null
  };
case GET_TRAINERS_SUCCESS:
  return {
    ...state,
    trainersLoading: false,
    trainers: action.payload.trainers,
    trainersTotal: action.payload.total,
    trainersError: null
  };
case GET_TRAINERS_FAILURE:
  return {
    ...state,
    trainersLoading: false,
    trainersError: action.payload
  };
  case REGISTER_ENTRY_REQUEST:
  return {
    ...state,
    entryLoading: true,
    entryMessage: null,
    entryError: null,
    entryUserData: null     // <-- reseteamos para evitar datos viejos
  };
case REGISTER_ENTRY_SUCCESS:
  return {
    ...state,
    entryLoading: false,
    entryMessage: action.payload.message,
    entryUserData: action.payload.user,  // guardamos datos del usuario
    entryError: null
  };
case REGISTER_ENTRY_FAILURE:
  return { ...state, entryLoading: false, entryError: action.payload };

case REGISTER_TRAINER_ENTRY_REQUEST:
  return { ...state, trainerEntryLoading: true, trainerEntryMessage: null, trainerEntryError: null };
case REGISTER_TRAINER_ENTRY_SUCCESS:
  return { ...state, trainerEntryLoading: false, trainerEntryMessage: action.payload, trainerEntryError: null };
case REGISTER_TRAINER_ENTRY_FAILURE:
  return { ...state, trainerEntryLoading: false, trainerEntryError: action.payload };
  case UPDATE_USER_REQUEST:
  return {
    ...state,
    userLoading: true,
    userError: null,
    userCreated: null
  };

case UPDATE_USER_SUCCESS: {
  const updatedUser = action.payload;
  const updatedUsers = state.users.map((user) =>
    user.id === updatedUser.id ? updatedUser : user
  );

  return {
    ...state,
    userLoading: false,
    userError: null,
    users: updatedUsers
  };
}
case UPDATE_USER_FAILURE:
  return {
    ...state,
    userLoading: false,
    userError: action.payload
  };
   case GET_USER_REQUEST:
      return { ...state, userLoading: true, userError: null };
    case GET_USER_SUCCESS:
      return { ...state, userLoading: false, user: action.payload.users };
    case GET_USER_FAIL:
      return { ...state, userLoading: false, userError: action.payload };
case CREATE_PAYMENT_REQUEST:
  return { ...state, paymentLoading: true, paymentError: null };

case CREATE_PAYMENT_SUCCESS:
  return {
    ...state,
    paymentLoading: false,
    paymentError: null,
    // Opcional: podrías agregar el pago a un array si guardás historial
  };

case CREATE_PAYMENT_FAILURE:
  return { ...state, paymentLoading: false, paymentError: action.payload };

case GET_USER_PAYMENTS_REQUEST:
  return { ...state, paymentLoading: true, userPayments: [], paymentError: null };

case GET_USER_PAYMENTS_SUCCESS:
  return { ...state, paymentLoading: false, userPayments: action.payload };

case GET_USER_PAYMENTS_FAILURE:
  return { ...state, paymentLoading: false, paymentError: action.payload };

case GET_MONTHLY_BALANCE_REQUEST:
  return { ...state, monthlyBalance: null, paymentLoading: true, paymentError: null };

case GET_MONTHLY_BALANCE_SUCCESS:
  return { ...state, paymentLoading: false, monthlyBalance: action.payload };

case GET_MONTHLY_BALANCE_FAILURE:
  return { ...state, paymentLoading: false, paymentError: action.payload };

case GET_GYM_BALANCE_REQUEST:
  return { ...state, gymBalance: null, paymentLoading: true, paymentError: null };

case GET_GYM_BALANCE_SUCCESS:
  return { ...state, paymentLoading: false, gymBalance: action.payload };

case GET_GYM_BALANCE_FAILURE:
  return { ...state, paymentLoading: false, paymentError: action.payload };
    default:
      return state;
  }
};

export default rootReducer;